export default "__VITE_ASSET__ISaabeom__"